<template>
    <div>
        <h2>買取データ登録画面</h2>

        <v-container class="py-4 py-lg-8">
            <v-row class="mt-6">
                <v-col cols="12" sm="6" lg="3" class="text-center">
                    <v-card>
                        <v-img :src="url_prefix + $route.params.card_image"></v-img>
                        <div class="pa-3">
                            <div>{{ $route.params.card_name }}</div>
                            <div>{{ $route.params.card_color }}</div>
                            <div>{{ $route.params.card_lot }}</div>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <h3>買取履歴</h3>
        <v-data-table
            :headers="headers"
            :items="entries"
            class="elevation-1"
            no-data-text="データはありません"
        >
        </v-data-table>

        <v-container fluid>
            <v-row align="center">
                <v-col class="d-flex" cols="12" sm="4">
                    <v-text-field v-model="buy_price" label="買取価格(円)" clearable></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-menu v-model="menu" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="buy_date" label="買取日" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                        </template>
                        <v-date-picker v-model="buy_date" @input="menu = false" :day-format="date => new Date(date).getDate()"></v-date-picker>
                    </v-menu>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-select v-model="buy_method" :items="buy_method_list" label="買取方法" clearable></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-select v-model="condition" :items="condition_list" label="カードの状態" clearable></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-text-field v-model="entry_quantity" label="数量" clearable></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-btn block color="primary" elevation="2" @click="postData">登録する</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>


<script>
export default {
    data: () => ({
        entries: [],
        menu: false,
        buy_price: '',
        buy_date: null,
        buy_method: '',
        condition: '',
        entry_quantity: null,
        buy_method_list: ['店舗買取', 'ネット買取', '仕入れ'],
        condition_list: ['S', 'A', 'B', 'C'],
        headers: [
            { text: 'カード名', value: 'card.card_name' },
            { text: '色', value: 'card.color' },
            { text: '収録弾', value: 'card.lot' },
            { text: '買取日', value: 'buy_date' },
            { text: '買取方法', value: 'buy_method' },
            { text: 'カードの状態', value: 'condition' },
            { text: '金額(円)', value: 'buy_price' },
            { text: '数量', value: 'entry_quantity' },
        ],
        url_prefix: "",
    }),
    methods: {
        postData() {
            this.axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/entry/register`, {
                operated_account: this.$store.getters.getStoreId,
                card: this.$route.params.card_id,
                buy_price: this.buy_price,
                buy_date: this.buy_date,
                buy_method: this.buy_method,
                condition: this.condition,
                entry_quantity: this.entry_quantity
            })
            .then(res => {
                this.$router.push({ name: 'Stocks' })
            })
            .catch((e) => {
                alert(e)
            })
        },
    },
    mounted: function () {
        this.url_prefix = `${process.env.VUE_APP_API_ORIGIN}`
        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/entry/search`, {
            params: {
                card_id: this.$route.params.card_id,
                operated_account: this.$store.getters.getStoreId
            }
        })
        .then(res => {
            this.entries = res.data
        })
        .catch(() => {
            alert(e)
        })
    }
}
</script>
